import { ROUTE_PATHS } from "@bcc/lib/constants";
import { TOUR_IDS } from "../tour-ids";
import type { FeatureTour } from "../tour.types";
import { tourTargetSelector } from "../tour.utils";

export const profileTour: FeatureTour = {
  id: "profile",
  titleKey: "tour.features.profile.title",
  order: 1,
  steps: [
    {
      id: "profile.menu",
      route: ROUTE_PATHS.HOME,
      target: tourTargetSelector(TOUR_IDS.profile.userNav),
      titleKey: "tour.steps.profile.menu.title",
      bodyKey: "tour.steps.profile.menu.body",
      placement: "bottom",
    },
  ],
};
